import { useElements, useStripe, CardElement } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import CurrencyFormat from "react-currency-format";
import { Link, useHistory } from "react-router-dom";
import ItemsInBasket from "../component/ItemsInBasket";
import { auth } from "../firebase";
import { useStateValue } from "../StateProvider";
import "../styles/Payment.css";
import axios from "../axios";

function Payment() {
  const [{ basket, user }] = useStateValue();
  const history = useHistory();

  const stripe = useStripe();
  const Elements = useElements();

  const [succeeded, setSucceeded] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState(true);

  // function to calculate the total price inside the busket array
  const totalPrice = () => {
    const pricesArr = basket.map((item) => item.price);
    var sum = pricesArr.reduce(function (a, b) {
      return a + b;
    }, 0);
    return sum;
  };

  useEffect(() => {
    // generate the special stripe secret which allows us to charge a custmer
    const geClientSecret = async () => {
      const response = await axios({
        method: "post",
        //stripe expected the total in a currency subunit if dollars so it's subunit is a cent so we muliply the value with 100
        url: `/payment/create?total=${totalPrice() * 100}`,
      });
      setClientSecret(response.data.clientSecret);
    };

    geClientSecret();
  }, [basket]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setProcessing(true);

    const payload = await stripe
      .confirmCardPayment(clientSecret, {
        payment_method: {
          card: Elements.getElements(CardElement),
        },
      })
      .then(({ paymentIntent }) => {
        // paymentIntent = payment confirmation
        setSucceeded(true);
        setError(null);
        setProcessing(false);

        history.replace("/orders");
      });
  };
  const handleChange = (event) => {
    // listen for changes in cardelement
    // and display the error as the customer types their card details

    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };

  return (
    <div className="payment">
      <div className="payment__container">
        <h1>
          Checkout ( <Link to="/checkout">{basket?.length} items </Link> )
        </h1>
        <div className="payment__section">
          <div className="payment__title">
            <h3>Delivery Address</h3>
          </div>
          <div className="payment__address">
            <p> {user ? auth.currentUser.email : "Hello Guest"}</p>
            <p>12 react Lane</p>
            <p> cairo Egypt </p>
          </div>
        </div>

        <div className="payment__section">
          <div className="payment__title">
            <h3>Review item and delivery</h3>
          </div>
          <div className="payment__items">
            {basket.map((item) => (
              <ItemsInBasket item={item} />
            ))}
          </div>
        </div>

        <div className="payment__section">
          <div className="payment__title">
            <h3>Payment Method</h3>
          </div>
          <div className="payment__details">
            <form onClick={handleSubmit}>
              <CardElement onChange={handleChange} />

              <div className="payment__priceContainer">
                <CurrencyFormat
                  prefix={"$"}
                  renderText={(value) => (
                    <>
                      <p>
                        Order Total : <strong>{value}</strong>
                      </p>
                    </>
                  )}
                  value={totalPrice()}
                  decimalScale={2}
                  displayType={"text"}
                  thousandSeparator={true}
                />
                <button disabled={processing || disabled || succeeded}>
                  <span>{processing ? <p>Processing </p> : "Buy Now"} </span>
                </button>
              </div>
              {error && <div>{error}</div>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Payment;
